import { mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from './store/actions/auth'
// import Toastr
import Toastr from 'vue-toastr';
import './assets/scss/app.scss'
// import toastr scss file: need webpack sass-loader
require('vue-toastr/src/vue-toastr.scss');
// Register vue component
import Vue from 'vue'

Vue.component('vue-toastr',Toastr);


  export default {
		name: 'app',
		data() { 
			return {
				servers:0,
				menuitems: {},
				wpuser: '',
				wppwd: '',
				wpbaseurl: '',
				redirecturl: '',
				fullwidth: document.documentElement.clientWidth
			}
		},
		
		
		
    methods: {
      open: function () {
        // console.log('slideoutOpen')
      },
      logout: function () {
				this.$store.dispatch(AUTH_LOGOUT).
					then(() => {
						this.$forceUpdate();
						this.$router.push({name: 'login', params: { 'message' : 'You have logged out successfully' }})
						this.$router.go()
					})
      },

		},
    computed: {
      ...mapGetters(['userdata', 'isAuthenticated', 'isProfileLoaded']),
      ...mapState({
        authLoading: state => state.auth.status === 'loading',
        name: state => `${state.user.profile.title} ${state.user.profile.name}`,
      })
    },
  	mounted() {
			this.$showRoles()
		},
		updated() {
		},
		created: function () {
			// console.log(this.userdata)
		},
		
  }

